import { styled } from '@mui/material/styles';
import { CardContent, Grid, Typography } from '@mui/material';

export const StyledHeader = styled(CardContent)(({ theme }) => ({
  width: '100%',
  height: '58px',
  backgroundColor: 'white',
  position: 'fixed',
  top: '0',
  left: '0',
  zIndex: 1000,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  fontFamily: 'Montserrat',
  padding: theme.spacing(0, 2),
}));

export const HeaderLabel = styled(Typography)({
  color: '#DF2020',
  fontWeight: 600,
  fontSize: '24px',
  lineHeight: '29.26px',
  marginLeft: '20px',
  marginTop: '5px',
});

export const LeftHeaderSection = styled(Grid)({
  display: 'flex',
  alignItems: 'center',
});
export const RightHeaderSection = styled(Grid)({
  display: 'flex',
  alignItems: 'center',
  marginRight: '32px',
});

export const WelcomeUserContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',
  marginTop: '5px',
});

export const HeaderIconsContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',
  marginTop: '5px',
});

export const UserName = styled(Typography)({
  color: '#DF2020',
  marginLeft: '6px',
  fontSize: '10.89px',
  fontWeight: 700,
  lineHeight: '13.27px',
});

export const CompanyLogoContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',
  marginTop: '5px',
});

export const VerticalLine = styled('div')({
  marginLeft: '16px',
  height: '32px',
  border: '1px solid #D4D4D4',
});

export const StyledImg = styled('img')({
  marginLeft: '13px',
  cursor: 'pointer',
});
